import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgError = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 70,
	height: 70,
	viewBox: "0 0 70 70",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M35.0013 67.0832C52.7204 67.0832 67.0846 52.719 67.0846 34.9998C67.0846 17.2807 52.7204 2.9165 35.0013 2.9165C17.2822 2.9165 2.91797 17.2807 2.91797 34.9998C2.91797 52.719 17.2822 67.0832 35.0013 67.0832ZM50.3949 45.8562L45.8577 50.3935L35.0013 39.5371L24.1449 50.3935L19.6077 45.8562L30.464 34.9998L19.6077 24.1435L24.1449 19.6062L35.0013 30.4626L45.8577 19.6062L50.3949 24.1435L39.5386 34.9998L50.3949 45.8562Z",
		fill: "#BF4A4C"
	})
});
export default SvgError;
